import { render } from "./UpdateProfileInformationForm.vue?vue&type=template&id=3803b5d9"
import script from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
script.render = render

export default script